import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: ""
}
const _hoisted_3 = {
  key: 1,
  class: "text-xs"
}

import { useMsal } from '@/composition-api/useMsal';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { currentUser } = useMsal();

const role = computed(()=>currentUser.value.roleDetails.map(r=>r.label).join(', '))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "inline-block px-4 text-right",
    title: _unref(currentUser).username
  }, [
    (!!_unref(currentUser).name)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(currentUser).name), 1))
      : _createCommentVNode("", true),
    (!!_unref(role))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(role)), 1))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})